import React from 'react'
import styles from './DragAndDrop.module.scss'
import sampleTemplate from '../../../assets/sample_image.png'
import sampleLogo from '../../../assets/school_logo.png'
import sampleQrCode from '../../../assets/qr_code.png'

export default function Box({ title, yellow, preview, align, textSize, font, personalizationBoxUrl }) {
  const backgroundColor = yellow ? 'rgba(255, 255, 255, 0.1)' : 'rgba(255, 255, 255, 0.3)'

  const DEFAULT_VALUES = {
    Barcode: 123456
  }

  const renderPreview = (title) => {
    if (title.includes('Image') || title.includes('Picture') || title.includes('Pose')) {
      return (
        <div className={styles.poseContainer}>
          <p className={styles.poseNumber}>{title}</p>
          <img src={sampleTemplate} className={styles.sampleImage} />
        </div>
      )
    }

    if (title.includes('Logo')) {
      return <img src={sampleLogo} className={styles.sampleImage} />
    }

    if (title.includes('QR')) {
      return <img src={sampleQrCode} className={styles.sampleImage} />
    }

    if (personalizationBoxUrl && !personalizationBoxUrl?.includes('missing')) {
      return <img src={personalizationBoxUrl} className={styles.sampleImage} />
    }

    return <>{DEFAULT_VALUES[title] || title}</>
  }

  return (
    <div
      className={`${styles.box} ${!title.includes('Image') && styles.content}`}
      style={{ backgroundColor, justifyContent: align, fontSize: `${textSize}px`, fontFamily: font }}
      role={preview ? 'BoxPreview' : 'Box'}
    >
      {renderPreview(title)}
    </div>
  )
}
